(function () {
    'use strict';

    function init() {
        const breadcrumbs = document.querySelectorAll('.js-breadcrumbs');
        if (!breadcrumbs) return;

        const expandedClass = 'breadcrumbs__item--expanded';
        const toggleClass = 'breadcrumbs__item--toggle';
        const overflowClass = 'breadcrumbs__item--overflow';

        function debounce(func, wait) {
            let timeout;

            return function executedFunction(...args) {
                const later = () => {
                    clearTimeout(timeout);
                    func(...args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        }

        function isOverflowed(element) {
            return element.scrollWidth > element.clientWidth;
        }

        function checkOverflow() {
            breadcrumbs.forEach((el) => {
                if (isOverflowed(el)) {
                    el.classList.add(overflowClass);
                } else {
                    el.classList.remove(overflowClass);

                    if (isOverflowed(el)) {
                        el.classList.add(overflowClass);
                    }
                }
            });
        }

        function toggleExpanded(element) {
            if (element.classList.contains(expandedClass)) {
                element.classList.remove(expandedClass);
            } else {
                element.classList.add(expandedClass);
            }
        }

        function injectExpander(element) {
            if (!element.querySelector(`.${toggleClass}`)) {
                const toggleDiv = document.createElement('div');
                toggleDiv.className = `breadcrumbs__item ${toggleClass} js-breadcrumbs-toggle`;

                const link = document.createElement('a');
                link.href = '#';
                link.className = 'breadcrumbs__link breadcrumbs__link--toggle';

                toggleDiv.appendChild(link);

                const firstChild = element.children[0];

                if (firstChild) {
                    firstChild.insertAdjacentElement('afterend', toggleDiv);
                } else {
                    element.appendChild(toggleDiv);
                }
            }
        }

        breadcrumbs.forEach((el) => injectExpander(el));
        checkOverflow();

        breadcrumbs.forEach((el) => {
            el.addEventListener('click', (e) => {
                const toggle = e.target.closest('.js-breadcrumbs-toggle');
                if (toggle) {
                    e.preventDefault();
                    toggleExpanded(toggle.closest('.js-breadcrumbs'));
                }
            });
        });

        const debouncedCheckOverflow = debounce(checkOverflow, 300);
        window.addEventListener('resize', debouncedCheckOverflow);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
